<template>
  <!-- 课程进度 -->
  <div class="page">
    <div class="pageIn">
      <div class="block1">
        <!-- 标题 -->
        <div class="flex tit">
          <div class="titImg">
            <img src="/static/images/new/mykc.png" />
          </div>
          <div class="flex dow" v-show="kcList.length>0">
            <a style="cursor: pointer;" :href="kcList.length>0?kcList[selectActive2].lxUrl:''">点我下载电子版材料</a>
            <i class="el-icon-caret-right"></i>
          </div>
        </div>
        <!-- 筛选1 完成与未完成-->
        <ul class="flex inner1">
          <li class="but" :class="selectActive1==item.id?'active':''" v-for="(item,index) in selectData1" :key="index"
            @click="selectActive1=item.id;getMyCourse()">{{item.tit}}</li>
        </ul>
        <!-- 筛选2 类型-->
        <ul class="flex inner2">
          <li :class="selectActive2==index?'active':''" v-for="(item,index) in kcList"  :key="index" @click="selectActive2=index;switchover();">{{item.lxName}}</li>
        </ul>
      </div>
      <!--课程list -->
      <div class="block2">
        <ul class="grid content">

          <li v-for="(item,index) in (kcList.length>0?kcList[selectActive2].kcList:[])" style="cursor:pointer" :key="index" @click="getDetail(item)">
            <!-- <div class="tag">共{{item.curriculum}}节</div> -->
            <div class="studying" v-if="item.recently==1">
              <img src="/static/images/new/studying.png" />
            </div>
            <div class="imgBox">
              <img :src="item.kcPic?item.kcPic:'/static/images/videoFm.png'" />
            </div>
            <div class="txtContent">
              <!-- <div class="flex dataNum">
                <span> <span>¥</span> {{item.price==0?"免费":item.price}}</span> <span>{{item.studyNum}}人已学</span>
              </div> -->
              <h3>{{item.kcMc}}</h3>
              <p>{{item.kcJs}}</p>
            </div>
          </li>

        </ul>
      </div>

      <!-- 进度条 正在培训展示进度条-->
      <!-- 已完成培训显示 || 还未开始培训-->
      <div class="accomplish">
        <verification ref="verification" :kcList='kcList' :kcData="kcData" :kcAllData="kcAllData"  :selectActive2='selectActive2' :enterpriseState='enterpriseState' ></verification>
      </div>
      <!--
      <div class="block3">
        <div class="flex block3Tit">
          <div class="flex titImg">
            <div class="circleBox">
              <div class="circle1"></div>
              <div class="circle2"></div>
            </div>
            <p>
              <span>{{kcList.length>0?kcList[selectActive2].lxName:''}}</span> <span>课程进度</span>
            </p>
          </div>
          <div class="select">

            <div class="xs">
              <span>{{selectValue.label.split(' ')[0]}}</span><span>{{selectValue.label.split(' ')[1]}}</span>
              <span><i class="el-icon-caret-bottom" color="#D3D2D2"></i></span>
            </div>
            <div class="yc">
              <el-select v-model="selectValue" value-key="id" placeholder="请选择" @change="selectChange">
                <el-option v-for="item in options" :key="item.id" :label="item.label" :value="item">
                </el-option>
              </el-select>
            </div>


          </div>
        </div>

        <div class="flex progress">
          <div class="flex left">
            <span>学习进度</span>
            <div class="progressBox">
              <el-progress :text-inside="true" :stroke-width="22" :percentage="kcList.length>0?parseInt((kcList[selectActive2].completed/kcList[selectActive2].lxAllPxsc)*100):0" status="success"></el-progress>
            </div>
            <div class="number">
              <span>{{kcList.length>0?timeNumber(kcList[selectActive2].completed):'00:00'}}</span><span>/{{kcList.length>0?timeNumber(kcList[selectActive2].lxAllPxsc):'00:00'}}</span>
            </div>
          </div>
          <div class="right">
            <el-button class="rBut" type="primary">未完成培训无法参加考试{{}}</el-button>
          </div>
        </div>
      </div> -->
    </div>

    <!-- 绑定企业的弹框 -->
    <el-dialog title="选择培训的企业" :visible.sync="dialogVisible" width="480px"  @submit.native.prevent :before-close="hangleClose">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" @submit.native.prevent class="demo-ruleForm">
        <p style="font-size: 16px; padding-left: 20px;padding-bottom: 50px;" v-if="flag == 2">您好，请先选择您要培训的类型</p>
        <p style="font-size: 16px; padding-left: 20px;padding-bottom: 50px;" v-else>
          您好，请先关联您要进行培训的
          <span style="color: red;">浙江省</span>企业：
        </p>
        <el-form-item label="企业名称" prop="priseName" v-if="flag != 2">
          <el-input v-model="ruleForm.priseName" style="width: 240px;" placeholder="请输入相关企业" :maxlength="25"
            clearable ></el-input>
        </el-form-item>

        <el-form-item label="选择类型" prop="lxId" v-if="flag != 0">
          <el-select :popper-append-to-body="false" v-model="ruleForm.lxId" placeholder="请选择类型" filterable clearable
            style="width: 240px;" @change="changeLx" >
            <el-option v-for="item in listData" :label="item.lxName" :value="item.lxId" :key="item.lxId"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button style="width: 220px;margin: 10px;" type="primary" @click="submitForm('ruleForm')">确定</el-button>
        </el-form-item>
        <div class="prise_center">
          <div class="prise_left" style="cursor: pointer;" v-if="flag != 2" @click="handleOpen">关联非浙江省企业></div>
          <!-- <div class="prise_left" style="cursor: pointer;" v-else @click="hangleProvinceIn">关联浙江省企业></div> -->
          <!-- <div class="prise_left">个人参加培训></div> -->
        </div>
      </el-form>
    </el-dialog>

  </div>

</template>

<script>
  import {
    cookie
  } from "@/common/js/cookies.js"
    import verification from "@/components/verify/verification.vue"
  export default {
    components: {
      verification
    },
    data() {
      return {
        selectActive1: 1,
        selectActive2: 0,
        dialogVisible:false,
        loading:null,
        kcList: [], //课程列表
        listData: [], //切换的数据类型
        kcAllData:{},//全部数据
        qyrz: false, //企业关联状态
        enterpriseState:null,//是否企业法人
        isAutoProcess: false, //是否开启自动流程跳转
        flag: 0, //来判断触发
        enterpriseId: null, //企业信息id
        qyId: null, //企业id
        lxId: null, //类型id
        selectData1: [{
          tit: '未完成',
          id: 1
        }, {
          tit: '已完成',
          id: 2
        }],
        selectData2: [{
          tit: '行政处罚与修复',
          id: 3
        }, {
          tit: '信用恢复课程第一部',
          id: 4
        }, {
          tit: '分类三',
          id: 5
        }, {
          tit: '分类四',
          id: 6
        }, {
          tit: '分类五',
          id: 7
        }],
        kcData: {},
        ruleForm: {
          priseName: null, //企业名字
          lxId: null, //类型id
        },
        rules: {
          priseName: [{
            required: true,
            message: "请输入企业名称",
            trigger: "blur",
          }, ],
          lxId: [{
            required: true,
            message: "请选择类型",
            trigger: "change",
          }, ],
        },
        selectValue: null,
        options: [],
      }
    },
    created() {

      this.getMyCourse();
    },
    computed: {
      token() {
        return cookie.get("xyxf_token_qt");
      },
    },

    methods: {
      // 清除表单
      hangleClose() {
        this.$refs["ruleForm"].resetFields();
        this.dialogVisible = false;
      },
      selectChange(val) {
        console.log(this.selectValue, '对象')
        // this.selectXs
        console.log(val)

      },
      // 转换
      timeNumber(val) {
        if (val < 10) {
          return '0' + val;
        } else {
          let second, minuteVal, minute, hour;
          if (val >= 60) {
            minuteVal = parseInt(val / 60);
            second = val - minuteVal * 60;
            if (minuteVal >= 60) {
              hour = parseInt(minuteVal / 60);
              minute = minuteVal - hour * 60;
              return this.timeT(hour) + ':' + this.timeT(minute) + ':' + this.timeT(second);
            } else {
              return this.timeT(minuteVal) + ':' + this.timeT(second);
            }
          } else {
            return '00:' + val;
          }

        }
      },
      timeT(val) {
        if (val < 10) {
          return '0' + val;
        } else {
          return val;
        }
      },
      // 切换
      switchover() {
        // this.getMyCourse();
        if (this.kcList.length > 0) {
          this.kcData = this.kcList[this.selectActive2];
        }
      },
      // 获取我的课程
      getMyCourse() {
        this.selectActive2=0;
        this.loading = this.$loading({
          lock: false,
          spinner: "el-icon-loading",
          background: "rgba(255, 255, 255, 0.5)",
        });
        this.$http.get(SOWINURL + 'zxpx/getMyCourse', {
          params: {
            flag: this.selectActive1
          }
        }).then(res => {
          if (res.data.result == 1 &&res.data.data) {
            let data=res.data.data;
            this.kcList = data.courseVoList;
            this.enterpriseState=data.sfQyfr;
            this.kcAllData=data;
			      this.kcData=this.kcList[this.selectActive2];
            this.getQyList();
          }else if(res.data.result == 1 && !res.data.data){
            // 无数据清空
            this.kcList = [];
            this.enterpriseState=null;
            this.kcAllData={};
            this.kcData={};
            this.getQyList();
          }else{
            this.loading.close();
          }
        }).catch(err => {
            this.loading.close();
        })
      },
      // 立即学习 详情
      getDetail(item) {
        this.lxId = this.kcList[this.selectActive2].lxId;
        // 是否登录
        if (!this.token) {
          console.log('未登录')
          this.$router.push('/');
          this.$message.error('请先登录');
        } else {
          if (this.qyrz == false) {
            this.dialogVisible = true;
          } else {
            this.getQyExist();
            // 详情
            // this.$router.push({
            //   path: "/courseDetail",
            //   query: {
            //     qyId: this.qyId,
            //     lxId: this.lxId
            //   },
            // });
          }

        }
      },
      // 获取企业列表
      getQyList() {
        this.$http.get(SOWINURL + 'index/getUserQy', {}).then(res => {
          if (res.data.result == 1) {
            let data = res.data.data;
            // this.qyList = res.data.data;
            // this.qyId = data.qyId;
            this.enterpriseId = data.currEnterprise.id;
            this.loading.close();
            // 企业 绑定状态
            if (data.enterpriseList.length < 1) {
              this.qyrz = false;
            } else {
              this.qyrz = true;
            }
          }else{
            this.loading.close();
          }
        }).catch(err => {
            this.loading.close();
        })
      },
      //关联浙江企业
      hangleProvinceIn() {
        if (this.clickTarget == "btn") {
          this.flag = 1;
        } else {
          this.flag = 0;
        }
      },
      changeLx(val) {
        let lxList = this.listData;
        let currentLxArr = lxList.filter((item) => item.lxId == val);
        this.sfnbg = currentLxArr[0].lxCjbg;
      },
      // 验证企业
      getQyExist() {
        this.$http.get(SOWINURL + 'getQyExist', {
          params: {
            lxId: this.lxId,
            enterpriseId: this.enterpriseId
          }
        }).then(res => {
          if (res.data.result == 1) {
            // 真实企业id
            this.qyId = res.data.data.qyId;
            this.getVideoDetail();

          }else {
            // console.log(res.data.data)
              this.$message({
                showClose: true,
                message: res.data.data,
                type: "error",
              });
            }
        }).catch(err => {

        })

      },
      //作用于来判断 点击下一步是什么功能
      getVideoDetail() {
        let _self = this;
        const loading = _self.$loading({
          lock: false,
          spinner: "el-icon-loading",
          background: "rgba(255, 255, 255, 0.5)",
        });
        _self.$http.post(SOWINURL+'XxKh/getVideoDetail',{
              kcId: null,
              lxId: _self.lxId,
              qyId: _self.qyId
          })
          .then(function(json) {
            loading.close();
            if (json.data.result == 1) {
              // 去看视频
              // let routerUrl = _self.$router.resolve({
              //   path: "/courseDetail",
              //   query: {
              //     lxId: _self.lxId,
              //     qyId: _self.qyId,
              //   },
              // });
              // window.open(routerUrl.href, "_blank");
              _self.$router.push({
                path: "/courseDetail",
                query: {
                  lxId: _self.lxId,
                  // kcId: _self.btnKcid,
                  qyId: _self.qyId,
                },
              });
            } else if (json.data.result == 400) {
              _self.isAutoProcess = false;
              // 点击视频没有关联企业开启自动流程把当前数据存起来
              let NEXT_DO_OBJ = {
                qyId: _self.qyId,
                lxId: _self.lxId,
                // kcId: _self.btnKcid,
              };
              localStorage.setItem("NEXT_DO_OBJ", JSON.stringify(NEXT_DO_OBJ));
              if (json.data.data.enterprise == 0) {
                //2，名下是否有企业
                _self.hangleRepair("open");
                // _self.$emit("hangleLength", 1, _self.activeOne);
                return;
              } else if (json.data.data.autonym == 0) {
                //1,实名
                _self.smrzClick();
                return;
              }  else if(json.data.data.check == 0){
                  _self.$message({
                    showClose: true,
                    message: '资料正在审核中',
                    type: "error",
                  });
              }else if (json.data.data.pay == 0) {
                // 3，是否支付
                _self.hangleZf();
                return;
              } else if (json.data.data.authorization == 0) {
                // 4，是否授权
                _self.$router.push({
                  path: "/yzf",
                  query: {
                    lxId: _self.lxId,
                    // kcId: _self.btnKcid,
                    qyId: _self.qyId,
                  },
                });
                return;
              } else {
                // 5,去考试
                _self.$router.push({
                  path: "/courseDetail",
                  query: {
                    lxId: _self.lxId,
                    qyId: _self.qyId,
                  },
                });
              }
            } else {
              _self.$message({
                showClose: true,
                message: json.data.errorcode,
                type: "error",
              });
            }
          })
          .catch(function(error) {
            loading.close();
            console.log(error);
          });
      },
      // 实名认证
      smrzClick() {
        this.$refs.verification.smrzClick();
        // this.$refs["smrz"].sign = 1;
        // this.$refs["smrz"].kcId = this.btnKcid;
        // this.$refs["smrz"].drawer = true;
      },
      // 支付
      hangleZf() {
        this.$router.push({
          path: "/dzf",
          query: {
            id: this.qyId,
            lxid: this.lxId,
          },
        });
      },
      // 点击去培训来判断
      hangleRepair(type) {
        if (type == "open") {
          this.isAutoProcess = true; //开启自动流程
        }
        this.flag = 0;
        this.clickTarget = "video";
        this.ruleForm.priseName = ""; //每次点击都空
        this.ruleForm.lxId = ""; //每次点击都空
        this.dialogVisible = true;
      },
      // 绑定企业
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if (this.flag == 0 || this.flag == 1) {
              // this.activeOne = this.ruleForm.lxId;
              this.getEnterprise();
            } else {
              // this.dialogVisible = false;
              // let routerUrl = this.$router.resolve({
              //   path: "/qyrz",
              //   query: {
              //     lxCjbg: this.sfnbg,
              //     qyActive: 1,
              //     pxlx: this.ruleForm.lxId,
              //   },
              // });
              // window.open(routerUrl.href, "_blank");
            }

            // this.$refs.btnClick.hangleVideo(_self.btnKcid);
          } else {
            console.log("error submit!!");
            return false;
          }
        });
      },
	  // 跳转外省企业
	  handleOpen(){
		this.dialogVisible = false;
		let routerUrl = this.$router.resolve({
		  path: "/qyrz",
		  query: {
		    lxCjbg: this.sfnbg,
		    qyActive: 1,
		    pxlx: this.ruleForm.lxId,
		  },
		});
		window.open(routerUrl.href, "_blank");
	  },
      // 判断进入是否有企业
      getEnterprise() {
        let _self = this;
        let ajax = _self.$http.create();
        const loading = _self.$loading({
          lock: false,
          spinner: "el-icon-loading",
          background: "rgba(255, 255, 255, 0.5)",
        });
        let formdata = new FormData();
        formdata.append("enterpriseName", _self.ruleForm.priseName);
        ajax({
            method: "post",
            url: SOWINURL + "index/getEnterprise",
            data: formdata,
          })
          .then(function(json) {
            loading.close();
            if (json.data.result == 200) {
              _self.uniscid = json.data.data;
              setTimeout(() => {
                _self.getAdd();
              }, 300);
            } else if (json.data.result == 404) {
              _self.$message({
                showClose: true,
                message: json.data.data,
                type: "error",
              });
            } else {
              _self.$message({
                showClose: true,
                message: json.data.errorcode,
                type: "error",
              });
            }
          })
          .catch(function(error) {
            console.log(error);
            loading.close();
          });
      },
      // 企业添加
      getAdd() {
        let _self = this;
        let ajax = _self.$http.create();
        const loading = _self.$loading({
          lock: false,
          spinner: "el-icon-loading",
          background: "rgba(255, 255, 255, 0.5)",
        });
        let formdata1 = new FormData();
        formdata1.append("enterpriseName", _self.ruleForm.priseName);
        // formdata1.append("lxId", _self.activeOne);
        formdata1.append("uniscid", _self.uniscid);

        ajax({
            method: "post",
            url: SOWINURL + "index/saveEnterprise",
            data: formdata1,
          })
          .then(function(json) {
            loading.close();
            if (json.data.result == 200) {
              _self.$message({
                showClose: true,
                message: "关联企业成功",
                type: "success",
              });
              _self.dialogVisible = false;
              _self.qyrz = true; //企业关联状态
              _self.enterpriseId = json.data.data.eid; // id
              _self.getQyExist();
              // _self.qyLength = 1;
              // _self.getUserQy();
              // _self.btnTrigger();
              // _self.getActive();
            } else {
              _self.$message({
                showClose: true,
                message: json.data.data,
                type: "error",
              });
            }
          })
          .catch(function(error) {
            console.log(error);
            loading.close();
          });
      },
    }
  }
</script>

<style scoped lang="less">
  .flex {
    display: flex;
  }

  .grid {
    display: grid;
  }

  .page {
    width: 100%;
  }

  .pageIn {
    width: 1180px;
    margin: 0 auto;
  }

  .circleBox {
    // position: relative;
    width: 30px;
    height: 22px;
    line-height: 22px;
    display: flex;
    align-items: center;

    .circle1 {
      background-color: #f49228;
      // position: absolute;
      // top: 50%;
      // margin-top: -6px;
      left: 0;
      width: 12px;
      height: 12px;
      border-radius: 50%;
      z-index: 99;
    }

    .circle2 {
      background-color: #fac994;
      margin-left: -4px;
      // position: absolute;
      // margin-top: -6px;
      // top: 50%;
      // left: 9px;
      width: 12px;
      height: 12px;
      border-radius: 50%;
    }
  }

  .block1 {
    margin: 20px 0;
    width: 100%;
    background-color: #FFFFFF;
    padding: 25px 15px;
    box-sizing: border-box;

    .tit {
      align-items: center;
      justify-content: space-between;
    }

    .inner1 {
      margin-top: 17px;

      li {
        width: 69px;
        height: 32px;
        border-radius: 8px;
        line-height: 32px;
        text-align: center;
        font-size: 14px;
        font-weight: 500;
        color: #777C94;
      }
      li:hover{
        cursor: pointer;
      }
      .active {
        background: #4698FF;
        color: #FFFFFF;
      }

    }

    .inner2 {
      margin-top: 16px;
      padding-top: 16px;
      border-top: 1px solid #EEF0F3;
      padding-bottom: 4px;

      li {
        font-size: 14px;
        font-weight: bold;
        color: #777C94;
        position: relative;
        margin-right: 42px;
        line-height: 22px;
      }
      li:hover{
        cursor: pointer;
      }
      .active {
        color: #4698FF;
      }

      .active::after {
        content: '';
        width: 18px;
        height: 4px;
        position: absolute;
        bottom: -8px;
        left: 50%;
        margin-left: -9px;
        background: #4698FF;
        border-radius: 3px;
      }
    }

    .dow {
      align-items: center;

      a {
        width: 162px;
        height: 18px;
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #007AFF;
        line-height: 18px;
        padding-bottom: 2px;
        border-bottom: 2px solid #0A7FFF;
      }

      i {
        font-size: 24px;
      }

      .el-icon-caret-right {
        color: #c2def6;
      }
    }
  }

  .block2 {
    .content {
      // flex-wrap: wrap;
      // justify-content: space-between;
      // align-items:center;
      // flex: 0 0 25%;
      grid-template-columns: repeat(4, 1fr);
      grid-column-gap: 20px;
      grid-row-gap: 30px;
      box-sizing: border-box;

      li {
        position: relative;
        background: #FFFFFF;
        box-shadow: 0px 2px 11px 6px rgba(0, 0, 0, 0.04);
        border-radius: 8px;
        height: 280px;
        margin-bottom: 30px;

        .studying {
          position: absolute;
          top: 0;
          right: 0;
          z-index: 99;
        }

        .tag {
          position: absolute;
          top: 0;
          left: 0;
          z-index: 99;
          width: 59px;
          height: 27px;
          border-radius: 8px 0px 16px 0px;
          background: rgba(0, 0, 0, 0.3);
          line-height: 27px;
          text-align: center;
          font-size: 14px;
          font-weight: 400;
          color: #FFFFFF;
        }

        .imgBox {

          // margin-bottom: 15px;
          width: 100%;
          height: 195px;
          img {
            width: 100%;
            height: 100%;
          }
        }

        .txtContent {
          padding: 15px 12px;
          box-sizing: border-box;

          .dataNum {
            width: 100%;
            justify-content: space-between;
            margin-bottom: 20px;

            span:first-child {
              font-size: 14px;
              font-weight: bold;
              color: #FF7327;

              span {
                font-size: 12px;
                color: #FF7327;
                font-weight: bold;
              }
            }

            span:last-child {
              font-size: 14px;
              font-weight: 300;
              color: #B5B5B5;
            }
          }

          h3 {
            font-size: 18px;
            font-weight: bold;
            color: #312120;
            margin-bottom: 8px;
          }

          p {
            font-size: 14px;
            font-weight: 400;
            color: #9A9A9A;
            width: 255px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }

    }
  }
</style>



// WEBPACK FOOTER //
// src/components/index/schedule.vue